import React from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  Alert02Icon,
  CheckmarkCircle01Icon,
} from "@hugeicons-pro/core-stroke-rounded";
import { Inline } from "components/layout/reusableLayouts";
import { Chip } from "@outpave/ds";

/**
 * Requirement-section heading: a compliance status glyph (green check when
 * satisfied, warning alert when the user still has something to fix)
 * followed by the section name, plus an "Exempt" pill when the policy
 * waives the requirement. Mirrors the admin Requirements accordions.
 */
const RequirementSectionTitle: React.FC<{
  ok: boolean;
  exempt?: boolean;
  children: React.ReactNode;
}> = ({ ok, exempt = false, children }) => {
  const { t } = useTranslation();
  return (
    <Inline gap="var(--space-4)" align="center">
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          color: ok ? "var(--color-text-success)" : "var(--color-text-warning)",
        }}
      >
        <HugeiconsIcon
          icon={ok ? CheckmarkCircle01Icon : Alert02Icon}
          size={16}
          color="currentColor"
        />
      </Box>
      <span>{children}</span>
      {/* No StatusGlyph: "Exempt" is a policy waiver, not a status in the
          DS vocabulary, so the info-tone fallback glyph would misread. */}
      {exempt && (
        <Chip tone="info" size="sm">
          {t("Exempt")}
        </Chip>
      )}
    </Inline>
  );
};

export default RequirementSectionTitle;
